import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import CustomSelect from "../../../../Components/CustomSelect";
import PercentIcon from "@mui/icons-material/Percent";
import FormNumberInput from "../../../../Components/FormNumberInput";

const Step3_InterestAndFees = ({
  interestTypeOptions,
  loanInterestFrequencyOptions,
  upfrontOptions,
  yesNoOptions,
}) => {
  const {
    control,
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();

  const interest_type = watch("interest_type");
  const loan_interest_frequency = watch("loan_interest_frequency");
  const upfront = watch("upfront");
  const insurance_fee = watch("insurance_fee");
  // const application_fee_amount = watch("application_fee_amount");

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="interest_type"
          id="interest_type"
          value={interest_type || ""}
          label="Interest type"
          onChange={(e) => setValue("interest_type", e.target.value)}
          options={interestTypeOptions}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="loan_interest_frequency"
          id="loan_interest_frequency"
          value={loan_interest_frequency || ""}
          label="Loan interest frequency"
          onChange={(e) => setValue("loan_interest_frequency", e.target.value)}
          options={loanInterestFrequencyOptions}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormNumberInput
          name="loan_interest_rate"
          control={control}
          label={`Loan interest rate`}
          min={0}
          disableGrouping={true}
          rules={{
            required: "Enter loan interest rate",
          }}
          endAdornment={
            <InputAdornment position="end">
              <PercentIcon />
            </InputAdornment>
          }
        />
        {/* <FormControl fullWidth error={!!errors.loan_interest_rate}>
          <InputLabel htmlFor="loan_interest_rate">
            Loan interest rate
          </InputLabel>
          <OutlinedInput
            id="loan_interest_rate"
            type="number"
            {...register("loan_interest_rate")}
            label="Loan interest rate"
            onWheel={(event) => event.target.blur()}
            inputProps={{ step: "any", min: 0 }}
            endAdornment={
              <InputAdornment position="end">
                <PercentIcon />
              </InputAdornment>
            }
            fullWidth
          />
          {errors.loan_interest_rate && (
            <FormHelperText>Enter loan interest rate</FormHelperText>
          )}
        </FormControl> */}
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="upfront"
          id="upfront"
          value={upfront || ""}
          label="Upfront"
          onChange={(e) => setValue("upfront", e.target.value)}
          options={upfrontOptions}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormNumberInput
          name="application_fee_p"
          control={control}
          label={`Application fee`}
          min={0}
          disableGrouping={true}
          rules={{
            required: "Enter an application fee",
          }}
          endAdornment={
            <InputAdornment position="end">
              <PercentIcon />
            </InputAdornment>
          }
        />

        {/* <FormControl fullWidth error={!!errors.application_fee_p}>
          <InputLabel htmlFor="application_fee_p">Application fee</InputLabel>
          <OutlinedInput
            id="application_fee_p"
            type="number"
            {...register("application_fee_p")}
            label="Application fee"
            onWheel={(event) => event.target.blur()}
            inputProps={{ step: "any", min: 0 }}
            fullWidth
            endAdornment={
              <InputAdornment position="end">
                <PercentIcon />
              </InputAdornment>
            }
          />
          {errors.application_fee_p && (
            <FormHelperText>Enter application fee</FormHelperText>
          )}
        </FormControl> */}
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="insurance_fee"
          id="insurance_fee"
          value={insurance_fee || ""}
          label="Insurance fee"
          onChange={(e) => setValue("insurance_fee", e.target.value)}
          options={yesNoOptions}
        />
      </Grid>

      {insurance_fee === "YES" && (
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormNumberInput
            name="insurance_p"
            control={control}
            label={`Insurance percentage`}
            min={0}
            rules={{
              required: "Enter an insurance percentage",
            }}
            disableGrouping={true}
            endAdornment={
              <InputAdornment position="end">
                <PercentIcon />
              </InputAdornment>
            }
          />

          {/* <FormControl fullWidth error={!!errors.insurance_p}>
            <InputLabel htmlFor="insurance_p">Insurance percentage</InputLabel>
            <OutlinedInput
              id="insurance_p"
              type="number"
              {...register("insurance_p")}
              label="Insurance percentage"
              onWheel={(event) => event.target.blur()}
              inputProps={{ step: "any", min: 0 }}
              fullWidth
              defaultValue="0"
              endAdornment={
                <InputAdornment position="end">
                  <PercentIcon />
                </InputAdornment>
              }
            />
            {errors.insurance_p && (
              <FormHelperText>Enter insurance percentage</FormHelperText>
            )}
          </FormControl> */}
        </Grid>
      )}

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormNumberInput
          name="grace_period_interest"
          control={control}
          label={`Grace period interest`}
          min={0}
          rules={{
            required: "Enter Grace period interest",
          }}
        />

        {/* <FormControl fullWidth error={!!errors.grace_period_interest}>
          <InputLabel htmlFor="grace_period_interest">
            Grace period interest
          </InputLabel>
          <OutlinedInput
            id="grace_period_interest"
            type="number"
            {...register("grace_period_interest")}
            label="Grace period interest"
            onWheel={(event) => {
              event.target.blur();
            }}
            inputProps={{
              step: "any",
            }}
            fullWidth
          />
          {errors.grace_period_interest && (
            <FormHelperText>Enter grace period interest</FormHelperText>
          )}
        </FormControl> */}
      </Grid>
    </Grid>
  );
};

export default Step3_InterestAndFees;
